import { Component, inject, OnInit } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { ThemeService } from '../../services/theme.service';
import { addIcons } from 'ionicons';
import { sunnyOutline, moonOutline } from 'ionicons/icons';

@Component({
  selector: 'app-theme-toggle',
  template: `
    <ion-button fill="clear" (click)="toggleTheme()" aria-label="Switch theme">
      <ion-icon slot="icon-only" [name]="isDarkMode ? 'sunny-outline' : 'moon-outline'"></ion-icon>
    </ion-button>
  `,
  styles: [`
    ion-icon {
      color: var(--ion-color-warning);
    }
  `],
  standalone: true,
  imports: [IonicModule],
})
export class ThemeToggleComponent implements OnInit {
  isDarkMode = false;
  private themeService = inject(ThemeService);

  constructor() {
    addIcons({ sunnyOutline, moonOutline });
  }

  ngOnInit() {
    this.themeService.darkMode$.subscribe(isDark => {
      this.isDarkMode = isDark;
    });
  }

  toggleTheme() {
    this.themeService.toggleDarkMode();
  }
}
